export class ChangeText {
    constructor(optionalOptions = {}) {
        this._changeTexts = document.querySelectorAll('.change--text');

        if (!this._changeTexts) {
            this.destructor();
            return true;
        }

        let linkDefaultText
        let linkText
        let target
        let targetObj
        let linkTextObj

        this._changeTexts.forEach((changeText) => {
            changeText.addEventListener("click", (event) => {
                event.preventDefault()

                linkDefaultText = changeText.dataset.defaulttext
                linkText = changeText.dataset.text
                target = changeText.dataset.target

                if (!target) {
                    return false
                }

                targetObj = document.querySelector(target);
                if (!targetObj) {
                    return false
                }

                linkTextObj = targetObj.querySelector('.more--text')

                if (!targetObj.classList.contains('opened')) {
                    targetObj.classList.add('opened')
                    linkTextObj.innerHTML = linkText
                    return false
                }

                targetObj.classList.remove('opened')
                linkTextObj.innerHTML = linkDefaultText
                return false
            })
        })
    }

    destructor() {
        this._changeTexts = null;
    }
}

export default new ChangeText();
